import valentinaImage from '/public/images/influencers/valentina.webp'
import jadeImage from '/public/images/influencers/jade2.webp'
import thaisImage from '/public/images/influencers/thais.webp'
import maluImage from '/public/images/influencers/malu2.webp'
import rachelImage from '/public/images/influencers/rachel2.webp'
import isabellaImage from '/public/images/influencers/isabella2.webp'
import brunaImage from '/public/images/influencers/bruna2.webp'
import chayImage from '/public/images/influencers/chay2.webp'
import thiagoImage from '/public/images/influencers/thiago2.webp'
import thamiresImage from '/public/images/influencers/thamires.webp'

export const INFLUENCERS = [
  {
    imageName: 'jade.webp',
    imageUrl: jadeImage,
    alt: 'Jade Picon',
    description: 'Atriz e Influencer',
    instagram: '@jadepicon',
    followers: '21.4'
  },
  {
    imageName: 'isabella.webp',
    imageUrl: isabellaImage,
    alt: 'Isabella Santoni',
    description: 'Atriz',
    instagram: '@isabellasantoni',
    followers: '10.3'
  },
  {
    imageName: 'bruna.webp',
    imageUrl: brunaImage,
    alt: 'Bruna Griphao',
    description: 'Atriz',
    instagram: '@brunagriphao',
    followers: '4.6'
  },
  {
    imageName: 'chay.webp',
    imageUrl: chayImage,
    alt: 'Chay Suede',
    description: 'Ator e Empreendedor',
    instagram: '@chay',
    followers: '4.6'
  },
  {
    imageName: 'thiago.webp',
    imageUrl: thiagoImage,
    alt: 'Thiago Martins',
    description: 'Ator e Cantor',
    instagram: '@thiagomartins',
    followers: '3.3'
  },
  {
    imageName: 'malu.webp',
    imageUrl: maluImage,
    alt: 'Malu Borges',
    description: 'Influencer',
    instagram: '@maluborgesm',
    followers: '2.9'
  },
  {
    imageName: 'rachel.webp',
    imageUrl: rachelImage,
    alt: 'Rachel Apollonio',
    description: 'Influencer e Empresária',
    instagram: '@rachelapollonio',
    followers: '1.9'
  },
  {
    imageName: 'thamires.webp',
    imageUrl: thamiresImage,
    alt: 'Thamires Hauch',
    description: 'Autora e Comunicadora',
    instagram: '@thamireshauch',
    followers: '1.8'
  },
  {
    imageName: 'valentina.webp',
    imageUrl: valentinaImage,
    alt: 'Valentina Bandeira',
    description: 'Atriz e Influencer',
    instagram: '@valenbandeira',
    followers: '1.3'
  },
  {
    imageName: 'thais.webp',
    imageUrl: thaisImage,
    alt: 'Thaís Vasconcellos',
    description: 'Influencer',
    instagram: '@thaisrvv',
    followers: '1.2'
  }
]
